import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";

import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import { countriesData } from "../../../components/Data/countries";

const AddModal = ({ getDataFromServer, setShowAddModal }) => {
  let navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  // Error Logging Service & Sanitize Input
  const [{ errorLogApi, placeHolderText }] = useAtom(gbState);

  const [formData, setFormData] = useState({
    label: "",
    no_of_digits: "",
    comments: "",
    country: "",
  });

  useEffect(() => {
    setCountries(countriesData.map((c) => ({ value: c.id, label: c.name })));
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();

    // ... existing handleAddSubmit logic ...
    let userToken = localStorage.getItem("token");

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/nationalidtype/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        toast.success("National ID type Created Successfully.");
        getDataFromServer();
        setShowAddModal(false);
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "AddModal", "/nationalidtype/add");
      });
  };

  const handleSelectChange = (field) => (selectedOption) => {
    setFormData((prev) => ({ ...prev, [field]: selectedOption }));
  };

  return (
    <div className="w-full p-3 bg-white rounded-lg shadow-lg">
      <h2 className="mb-4 text-2xl font-semibold">Add New National iD Type</h2>
      <form className="space-y-4" onSubmit={handleAddSubmit}>
        <div className="md:flex md:space-x-3">
          <div className="w-full">
            <label className="block mb-1 text-sm font-medium" htmlFor="label">
              National ID Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="label"
              id="label"
              value={formData.label}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              required
            />
          </div>
          <div className="w-full">
            <label
              className="block mb-1 text-sm font-medium"
              htmlFor="no_of_digits"
            >
              Total No of Char(s)/Digits
            </label>
            <input
              type="text"
              name="no_of_digits"
              id="no_of_digits"
              value={formData.no_of_digits}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none"
            />
          </div>
          <div className="w-full">
            <label htmlFor="country" className="block mb-1 font-small">
              Country <span className="text-red-500">*</span>
            </label>
            <Select
              options={countries}
              value={formData.country}
              onChange={handleSelectChange("country")}
              placeholder="Select Country"
              className="text-base"
              menuPosition="fixed"
            />
          </div>
        </div>
        <div className="md:flex md:space-x-1">
          <div className="w-full">
            <label className="block mb-1 text-sm font-medium" htmlFor="address">
              Comments
            </label>
            <textarea
              name="comments"
              id="comments"
              value={formData.comments}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              rows={3}
            />
          </div>
        </div>
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            className="px-4 py-2 text-white bg-gray-500 rounded-md shadow-sm btn btn-secondary hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            onClick={() => setShowAddModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-white bg-indigo-600 rounded-md shadow-sm btn btn-primary hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddModal;
